import { type FC } from 'react'
import { MeetingTypeIcon } from '../../MeetingPreparation/MeetingInfo/MeetingTypeIcon'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'

export interface MeetingTypeProps {
  meetingType: string
}
const IN_PERSON = 'In Person'

const mapping: { [key: string]: string } = {
  zoom: 'Zoom',
  meet: 'Google Meet',
  teams: 'Microsoft Teams',
  phone: 'Phone',
  import: 'Imported',
  'voice-memo': IN_PERSON,
  'voice-memo-desktop': IN_PERSON,
  'voice-memo-mobile': IN_PERSON,
  '': IN_PERSON,
  webex: 'Webex',
  'phone-ringcentral': 'RingCentral',
  'phone-goto': 'GoTo',
  'phone-zoom_phone': 'Zoom Phone',
}

export const MeetingType: FC<MeetingTypeProps> = ({ meetingType }) => {
  const meetingTypeDescription = mapping[meetingType] || '-'

  return (
    <div className='d-flex gap-2 align-items-center'>
      <MeetingTypeIcon meetingType={meetingType} />
      <Tooltip title='Meeting platform' placement='bottom'>
        {meetingTypeDescription}
      </Tooltip>
    </div>
  )
}
